var map = {
	"./aparthotelclub/ic_tag_activity.png": 86902,
	"./beachful/ic_tag_activity.png": 61088,
	"./castlepedia/ic_tag_activity.png": 80420,
	"./cocktayl/ic_tag_activity.png": 16803,
	"./ic_tag_activity.png": 63505,
	"./luxresortclub/ic_tag_activity.png": 75414,
	"./parkful/ic_tag_activity.png": 7146,
	"./prefabworld/ic_tag_activity.png": 82229,
	"./rooftopclub/ic_tag_activity.png": 68492,
	"./spaclub/ic_tag_activity.png": 60626,
	"./worldcasino/ic_tag_activity.png": 20964,
	"./zoopedia/ic_tag_activity.png": 90785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48091;